import {AxiosPublicationsInstance} from "../api/AxiosInstance";

export const searchUsers = async (search) => {
  try {
    const payload = {
      criteria: search?.criteria ?? search?.Criteria ?? "",
      idUsuario: search?.idUsuario ?? search?.IdUsuario ?? null,
      conInteraccion: search?.conInteraccion ?? true,
      hashtag: search?.hashtag ?? false,
      arroba: search?.arroba ?? false,
      nombre: search?.nombre ?? false,
    };

    const response = await AxiosPublicationsInstance.post("/api/motor/busqueda-general", payload)
    return response?.data?.data ?? response.data
  } catch (error) {
    throw error?.response || "Failed user search"
  }
}

export const getAnotherUserInfo = async (userId, otherId) => {
  try {
    const response = await AxiosPublicationsInstance.get(`/api/info/conex?IdUsuario=${userId}&IdAmigo=${otherId}`)
    return response.data
  } catch (error) {
    throw error?.response || "Failed get user info"
  }
}

export const unFollow = async (relation) => {
  try {
    const response = await AxiosPublicationsInstance.post("/api/dejar/seguir", relation)
    return response.data
  } catch (error) {
    throw error?.response || "Failed while unfollowing"
  }
}

export const getBlockedList = async (userId) => {
  try {
    const response = await AxiosPublicationsInstance.get(`/api/obtener/usuarios-bloqueados?idUsuario=${userId}`)
    return response.data
  } catch (error) {
    throw error?.response || "Failed getting blocked list"
  }
}
